var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _rect7, _rect8, _g2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g3, _rect15, _rect16, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgNavFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    width: 2,
    preserveAspectRatio: "none",
    viewBox: "0 0 2 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 1,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 80,
    transform: "translate(1)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_106)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    width: 1440,
    height: 80,
    fill: "url(#paint0_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1438,
    y: 0,
    width: 1440,
    height: 80
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    width: 1440,
    height: 80,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_106)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 811,
    transform: "translate(-1438 -432)",
    fill: "url(#paint1_linear_1_106)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    y: -432,
    width: 1440,
    height: 811,
    fill: "url(#paint2_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1438,
    y: -432,
    width: 1440,
    height: 811
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    y: -432,
    width: 1440,
    height: 811,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_106)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    width: 1440,
    height: 80,
    fill: "url(#paint3_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1438,
    y: 0,
    width: 1440,
    height: 80
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -1438,
    width: 1440,
    height: 80,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_106)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2011,
    height: 1133,
    transform: "translate(-2009 -381)",
    fill: "url(#paint4_linear_1_106)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1133,
    height: 2011,
    transform: "matrix(0 1 1 0 -2009 -381)",
    fill: "url(#paint5_linear_1_106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1016.6 -381C-1016.6 -381 -1069.23 -80.0196 -1232.49 209.993C-1395.76 500.006 -1698.76 752 -1698.76 752L2.00004 752V-381L-1016.6 -381Z",
    fill: "url(#paint6_linear_1_106)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 80
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 80,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_106)"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    width: 1440,
    height: 80,
    fill: "url(#paint7_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 1441,
    height: 80
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    width: 1440,
    height: 80,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_106)"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 811,
    transform: "translate(-0.5 -432)",
    fill: "url(#paint8_linear_1_106)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -432,
    width: 1440,
    height: 811,
    fill: "url(#paint9_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -432,
    width: 1441,
    height: 811
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -432,
    width: 1440,
    height: 811,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_106)"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    width: 1440,
    height: 80,
    fill: "url(#paint10_linear_1_106)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_106",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 1441,
    height: 80
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    width: 1440,
    height: 80,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_106)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2011,
    height: 1133,
    transform: "translate(-571.5 -381)",
    fill: "url(#paint11_linear_1_106)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1133,
    height: 2011,
    transform: "matrix(0 1 1 0 -571.5 -381)",
    fill: "url(#paint12_linear_1_106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.902 -381C420.902 -381 368.272 -80.0196 205.006 209.993C41.7412 500.006 -261.259 752 -261.259 752L1439.5 752V-381L420.902 -381Z",
    fill: "url(#paint13_linear_1_106)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_106",
    x1: -718,
    y1: 0,
    x2: -718,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_106",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_106",
    x1: -1438,
    y1: -432,
    x2: 1.63322,
    y2: 379.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_106",
    x1: -718,
    y1: 0,
    x2: -718,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_106",
    x1: 1005.5,
    y1: 0,
    x2: 1005.5,
    y2: 1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_106",
    x1: 651.669,
    y1: 1302.9,
    x2: -1161.44,
    y2: -229.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_106",
    x1: -1779.38,
    y1: 51.295,
    x2: 89.2168,
    y2: 402.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_106",
    x1: 719.5,
    y1: 0,
    x2: 719.5,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_106",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_106",
    x1: -0.5,
    y1: -432,
    x2: 1439.13,
    y2: 379.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_106",
    x1: 719.5,
    y1: 0,
    x2: 719.5,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_106",
    x1: 1005.5,
    y1: 0,
    x2: 1005.5,
    y2: 1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_106",
    x1: 651.669,
    y1: 1302.9,
    x2: -1161.44,
    y2: -229.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_106",
    x1: -341.876,
    y1: 51.295,
    x2: 1526.72,
    y2: 402.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNavFill);
export default __webpack_public_path__ + "static/media/bg-nav-fill.b61e8968cd88f9c93787ce0d21057211.svg";
export { ForwardRef as ReactComponent };